import Vue from "vue";
import Vuex from "vuex";
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

const initialState = () => {
  return {
    company: {
      name: 'Cursos Centro Multidisciplinar Fuminense',
      footerTxt: 'Centro Multidisciplinar Fuminense',
      website: 'www.centrofluminense.com.br',
      url: 'https://www.centrofluminense.com.br',
      SEO: {},
      paragraphs: [
        'Fundado em 2012, o Centro Multidisciplinar Fluminense tornou-se referência em saúde, principalmente na área de reumatologia. Venha consultar-se onde sua saúde vem em primeiro lugar!',
        'Somos um Centro Multidisciplinar cujo principal objetivo é a Saúde Global. Buscamos adotar um olhar interdisciplinar no tratamento das doenças, e ao mesmo tempo promover a saúde fora do consultório através de eventos voltados tanto para médicos e quanto para pacientes.',
      ],
      social: [
        // {
        //   name: 'Facebook',
        //   i: 'mdi-facebook',
        //   href: ''
        // },
        {
          name: 'Instagram',
          i: 'mdi-instagram',
          href: 'https://www.instagram.com/cursoscentrofluminense/'
        },
        {
          name: 'LinkedIn',
          i: 'mdi-linkedin',
          href: 'https://www.linkedin.com/company/cursos-centro-multidisciplinar-fluminense/'
        },
      ],
    },
    user: null,
    userData: null,
    loadingPage: null,
    error: null,
    adminToken: null,
    loggedIn: null,
    loginDialog: false,
    emailChecked: false,
    forgotDialog: false,
    registerDialog: false,
    feedbackModal: false,
    feedback: {},
    goLiveEnabled: false,
    video: {},
    videos: [],
  };
}

export default new Vuex.Store({
  plugins: [createPersistedState({
    paths: ['user', 'adminToken'],
    storage: window.sessionStorage,
    // Use sessionStorage.clear(); when logged out manually
  })],
  state: initialState(),
  mutations: mutations,
  actions: actions,
  modules: {},
  getters: getters
})